import * as React from "react";
import { forwardRef } from "react";
const SvgTraces = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M15.5 1c.3 0 .5.2.5.5v.7c0 .3-.2.5-.5.5H.5c-.3 0-.5-.2-.5-.5v-.7c0-.3.2-.5.5-.5h15zM15.5 4.1c.3 0 .5.2.5.5v.7c0 .3-.2.5-.5.5H.5c-.3 0-.5-.2-.5-.5v-.7c0-.3.2-.5.5-.5h15zM5.6 7.1c.3 0 .5.2.5.5v.7c0 .3-.2.5-.5.5H.5c-.3.1-.5-.2-.5-.4v-.8c0-.3.2-.5.5-.5h5.1zM15.5 13.3c.3 0 .5.2.5.5v.7c0 .3-.2.5-.5.5h-3.2c-.3 0-.5-.2-.5-.5v-.7c0-.3.2-.5.5-.5h3.2zM11.3 10.2c.3 0 .5.2.5.5v.7c0 .3-.2.5-.5.5H6.6c-.3 0-.5-.2-.5-.5v-.7c0-.3.2-.5.5-.5h4.7z" }));
const ForwardRef = forwardRef(SvgTraces);
export default ForwardRef;
